import Container from '../pages/Main/sections/Container';
import Reveal from './Reveal';

/**
 * Shared hero band for secondary pages (legal, contact, blogs, careers, about).
 * Dark, centered, with ambient glow + grid — matches the redesigned theme.
 */
const PageHero = ({ eyebrow, title, titleAccent, subtitle }) => (
  <section className="relative overflow-hidden pb-8 pt-16 text-center md:pt-24 lg:pt-28">
    <div className="glow left-1/2 top-[-120px] h-[360px] w-[560px] -translate-x-1/2 bg-accent/12" />
    <div className="pointer-events-none absolute inset-0 grid-overlay opacity-50" />

    <Container className="relative">
      {eyebrow && (
        <Reveal>
          <span className="eyebrow">{eyebrow}</span>
        </Reveal>
      )}
      <Reveal delay={80}>
        <h1 className="font-heading mx-auto mt-5 max-w-4xl text-[2.2rem] font-bold leading-[1.1] sm:text-[3rem] lg:text-[3.4rem]">
          <span className="head-fade">{title}</span>
          {titleAccent && (
            <>
              {' '}
              <span className="text-accent-grad">{titleAccent}</span>
            </>
          )}
        </h1>
      </Reveal>
      {subtitle && (
        <Reveal delay={160}>
          <p className="mx-auto mt-5 max-w-2xl text-[0.98rem] leading-relaxed text-white/55">
            {subtitle}
          </p>
        </Reveal>
      )}
    </Container>
  </section>
);

export default PageHero;
